module.exports = __webpack_public_path__ + "img/tab-fonc-5.386710d7.png";